<template>
  <div id="department">
      <TemplateLayout>
        <!-- Page Heading -->
        <a class="float-right btn btn-primary btn-sm" style="margin-top: -5px" href="javascript:;" @click="openUpdate('','')">
            <i class="fas fa-plus-circle fa-fw"></i>
            สร้างใหม่
        </a>
                
        <h1 class="h3 mb-2 text-gray-800">ข้อมูลแผนก</h1>
        <p class="mb-4">ผู้ดูแลระบบสามารถสร้างข้อมูลแผนก สามารถตั้งค่าแผนก เพิ่ม ลบ และแก้ไข เพื่อใช้ระบุข้อมูลแผนกผู้ใช้ในหน้า "บัญชีผู้ใช้งาน"</p>

        <!-- DataTales Example -->
        <div class="card shadow mb-4">
            <div class="card-header py-3">
            
                <h6 class="m-0 font-weight-bold text-primary">รายการทั้งหมดในระบบ</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 80px">ลำดับ</th>
                                <th>ชื่อแผนก</th>
                                <th class="text-center" style="width: 100px">จัดการ</th>
                            </tr>
                        </thead>
                        <tfoot>
                            <tr>
                                <th class="text-center" style="width: 80px">ลำดับ</th>
                                <th>ชื่อแผนก</th>
                                <th class="text-center" style="width: 100px">จัดการ</th>
                            </tr>
                        </tfoot>
                        <tbody>
                            <tr v-for="(item,index) in items" :key="item.department_id">
                                <td class="text-center">{{ (index+1) }}</td>
                                <td>{{ item.department_name }}</td>
                                
                                <td class="text-center">
                                    <a href="javascript:;" @click="openUpdate(item.department_id,item.department_name)">
                                        <i class="fas fa-pen-alt fa-fw"></i>
                                    </a>
                                    &nbsp;
                                    <a href="javascript:;" @click="deleteUpdate(item.department_id)">
                                        <i class="fas fa-trash fa-fw text-danger"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="modal" id="modal-master" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">รายละเอียด</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-primary">
                                  <label>
                                    <b class="text-primary">ชื่อแผนก</b>
                                  </label>
                                  <input placeholder="ระบุชื่อ" v-model="master_name" type="text" class="form-control mb-2">
                                  </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary mt-2" @click="saveMasterData">
                            <i class="fas fa-save fa-fw"></i>
                            บันทึกรายการ
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">ปิด</button>
                    </div>
                </div>
            </div>
        </div>
      </TemplateLayout>
  </div>
</template>

<script>

import TemplateLayout from "@/components/layout/TemplateLayout.vue";
import { MasterService } from '@/services/master.service';
import { AlertService } from '@/services/alert.service';

export default {
  name: 'Department',
  components: {
    TemplateLayout
  },
  data() {
    return {
      objective : "department",
      items : [],
      master_id : "",
      master_name : ""
    }
  },
  methods: {
    async bindItemData()
    {
      this.items = await MasterService.getMasterList(this.objective);
    },
    openUpdate(val,name){
      this.master_id = val;
      this.master_name = name;
      window.$("#modal-master").modal('show');
    },
    async saveMasterData()
    {
        AlertService.loading(true,"บันทึกข้อมูล");
        const respons = await MasterService.saveMasterList(this.objective,this.master_id,{ dept_id : this.master_id, dept_name : this.master_name });
        if(respons.status == 200){
          this.bindItemData();
          window.$("#modal-master").modal('hide');
          AlertService.success("บันทึกสำเร็จ");
        }
        else
        {
          AlertService.error(respons.message);
        }
        AlertService.loading(false);
    },
    async deleteUpdate(id){

      if(AlertService.confirm("ยืนยันรายการ?")){
        AlertService.loading(true,"ลบข้อมูล");
        const respons = await MasterService.deleteMaster(this.objective,id);
        if(respons.status == 200){
            this.bindItemData();
            AlertService.success("บันทึกสำเร็จ");
        }else
        {
            AlertService.error(respons.message);
        }
        AlertService.loading(false);
      }  

    }
  },
  mounted() {
    this.bindItemData();
  }
}
</script>

<style>

</style>